import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1. Ant Design
import { Button, Card, Flex, message, Skeleton, Tag, Typography } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
// 2. External libraries
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
// 3. Internal components
import TariffPairForm from "@/components/TariffPairForm";
// 4. Stores
import { getRootStore } from "@/stores/RootStore";
// 5. Types, utils, styles
import { isAdmin } from "@/utils/permissions";
import styles from "@/styles/TariffPage.module.less";
const { Title } = Typography;
/** UC702: общая пара тарифов. Форма — общий компонент TariffPairForm (FR-006, режим «general»). */
const TariffPage = observer(() => {
    const navigate = useNavigate();
    const { id: advanceId } = useParams();
    const { singleTariffStore: store, authStore: { userRole }, } = getRootStore();
    const canEdit = isAdmin(userRole);
    useEffect(() => {
        store.init(advanceId);
        return () => {
            store.dispose();
        };
    }, [advanceId]);
    const pair = store.pair;
    const handleSubmit = async (nextPair) => {
        const result = await store.savePair(nextPair);
        if (result) {
            message.success(pair ? "Тариф обновлён" : "Тариф создан");
            navigate("/tariffs");
        }
    };
    if (store.isLoading) {
        return (_jsx(Card, { children: _jsx(Skeleton, { active: true, paragraph: { rows: 8 } }) }));
    }
    return (_jsxs("div", { className: styles.container, children: [_jsxs(Flex, { justify: "space-between", align: "center", className: styles.header, children: [_jsx(Button, { icon: _jsx(ArrowLeftOutlined, {}), onClick: () => navigate("/tariffs"), children: "\u041A \u0441\u043F\u0438\u0441\u043A\u0443" }), _jsx(Title, { level: 4, style: { margin: 0 }, children: pair ? `Тариф: ${pair.advance.name}` : "Новый тариф" }), _jsx("div", {})] }), _jsxs(Card, { children: [_jsx(TariffPairForm, { mode: "general", pair: pair, canEdit: canEdit, isSaving: store.isSaving, onSubmit: handleSubmit, onCancel: () => navigate("/tariffs") }), pair && (_jsx(Tag, { color: pair.late ? "orange" : "default", style: { marginTop: 12 }, children: pair.late
                            ? `LATE-двойник: ${pair.late.id}`
                            : "LATE-двойник отсутствует" }))] })] }));
});
export default TariffPage;
